import styled from 'styled-components';
import { breakpoints } from '@theme/breakpoints';
import { rem } from 'polished';

export default styled.div`
  background-color: #fff;
  display: flex;
  align-items: flex-start;
  padding: 5px 20px;
  margin: 0 10px;
  @media ${breakpoints.mobilelgMax} {
    padding-bottom: ${rem(5)};
  }
`;
